import EnumList from "./EnumList";

class UserRoles extends EnumList {
  constructor() {
    super();

    this.STANDARD = this.add(0, "Standard");
    this.CONTRACTMANAGER = this.add(1, "Contract manager");
    this.ADMINISTRATOR = this.add(2, "i-Theses Administrator");    
  }
}

export default UserRoles;



// WEBPACK FOOTER //
// ./src/Stores/DataStore/Enums/UserRoles.js